import React from 'react';
import { useSelector } from 'react-redux';
import { map } from 'lodash';
import { BlackToastTrigger } from '@bbkAdminComponents/alerts/black-toast';
import {
  AsyncInputSelect,
  AsyncMultiInputSelect,
} from '@bbkAdminComponents/select/select';
import { selectAppId } from '@bbkAdminRedux/app/selectors';
import { integrationSlice } from '@bbkAdminRedux/rtkq/integrations.slice';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

export const ListOfValueSelector: ReactFCC<{
  value?: string | string[];
  fieldName: string;
  isMulti?: boolean;
  integration_id: number;
  menuPosition?: 'absolute' | 'fixed';
  onChange: (value?: string | string[]) => unknown;
}> = ({
  value,
  isMulti,
  integration_id,
  menuPosition,
  onChange,
  fieldName,
}) => {
  const [loadFieldValues] =
    integrationSlice.endpoints.loadFieldValues.useLazyQuery();
  const appKey = useSelector(selectAppId);

  const CreateNewOptionComponent = (inputValue: string) => (
    <div className="tw-border-t tw-border-black">
      Select <span className="tw-italic">{inputValue}</span>
    </div>
  );

  const loadOptions = (input: string, callBack: (e: any) => unknown) => {
    loadFieldValues({
      appKey,
      fieldName: fieldName,
      integrationId: integration_id,
      text: input,
    })
      .unwrap()
      .then((response) => {
        const loadedValues = map(
          response as { key: string; display_name: string }[],
          (field) => ({
            value: field.key,
            label: field.display_name,
          })
        );
        callBack(loadedValues);
      })
      .catch((e) => {
        console.error(e);
        BlackToastTrigger({
          content: 'Unable to load values',
          options: { autoClose: 1000 },
        });
      });
  };
  if (isMulti) {
    return (
      <AsyncMultiInputSelect
        showDefaultOptions
        formatCreateLabel={CreateNewOptionComponent}
        value={value as string[]}
        loadOptions={loadOptions}
        onSelect={onChange}
        menuPosition={menuPosition}
      />
    );
  }

  return (
    <AsyncInputSelect
      showDefaultOptions
      formatCreateLabel={CreateNewOptionComponent}
      value={value as string}
      loadOptions={loadOptions}
      onSelect={onChange}
      menuPosition={menuPosition}
    />
  );
};
